<template>
    <div>
        <b-row>
            <b-col>

                <b-form @keyup.enter="load">
                    <b-card bg-variant="light">
                        <b-form-row>
                            <b-col lg="2" sm="12" class="text-left">
                                <lg-form-const-select @change="load" label="Situação:" v-model="form.situacao"
                                    :options="form.optionsFilterSituacao" />
                            </b-col>

                            <b-col lg="4" sm="12" class="text-left">
                                <lg-form-input invalidFeedback="Informe o nome" description="" v-model="form.descricao"
                                    label="Nome:" maxlength="200" />

                            </b-col>

                            <b-col cols="4" class="text-right">
                                <b-button id="limparFotoIBP" class="mr-2 my-2" size="sm" style="height: 20px" pill
                                    variant="primary" @click="clearForm">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" /> &nbsp;
                                    </div>
                                    <b-tooltip target="limparFotoIBP" title="Limpar"></b-tooltip>
                                </b-button>
                                <b-button id="localizarFotoIBP" class="mr-2 my-2" size="sm" style="height: 20px" pill
                                    variant="primary" @click="load">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" /> &nbsp;
                                    </div>
                                    <b-tooltip target="localizarFotoIBP" title="Localizar"></b-tooltip>

                                </b-button>
                            </b-col>

                            <b-col cols="1">
                                <b-button id="adicionarNovo" class="mr-2 my-2" size="sm" style="height: 20px" pill
                                    variant="primary" @click="cadastrar">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="plus" /> &nbsp;
                                    </div>
                                    <b-tooltip target="adicionarNovo" title="Adicionar novo..."></b-tooltip>

                                </b-button>
                            </b-col>
                        </b-form-row>

                    </b-card>
                    <b-card bg-variant="light">

                        <b-form-row class="col-12">
                            <b-table class="col-12" responsive="sm" stacked="sm" small outlined sticky-header show-empty
                                head-variant="light" :busy="this.busy" :items="this.records" :fields="itensFields">
                                <template #table-busy>
                                    <div class="text-center text-primary my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>

                                <template #empty>
                                    <h6 style="text-align: center">Nenhum item vinculado</h6>
                                </template>

                                <template v-slot:cell(principal)="{ item }">
                                    
                                    <b-icon class="hand-pointer" @click="atualizarPrincipal(item.cod)"
                                        :icon="item.principal == 1?'star-fill':'star'" font-scale="2"
                                        style="color: #008ccdd0"></b-icon>
                                </template>

                                <template v-slot:cell(edit)="row">

                                    <b-button :id="row.index + 'edit-button-foto'" class="my-2" size="sm" pill
                                        variant="primary" @click="editar(row.item)">
                                        <b-icon icon="pencil-square" />
                                        <b-tooltip :target="row.index + 'edit-button-foto'"
                                            title="Editar..."></b-tooltip>
                                    </b-button>

                                </template>

                                <template v-slot:cell(desativar)="row">

                                    <div :id="row.index + 'ativar-fotoibp'">
                                        <b-form-checkbox v-model="row.item.situacao" switch :value="1"
                                            :unchecked-value="0" @change="alteraSituacao(row.item)" />
                                        <b-tooltip :target="row.index + 'ativar-fotoibp'"
                                            title="Ativar/Desativar..."></b-tooltip>
                                    </div>

                                </template>

                                <template v-slot:cell(remover)="row">
                                    <b-button :id="row.index + 'excluir'" class="my-2" size="sm" pill variant="primary"
                                        @click="deletar(row.item.cod)">
                                        <b-icon icon="trash-fill" />
                                        <b-tooltip :target="row.index + 'excluir'" title="Remover..."></b-tooltip>
                                    </b-button>

                                </template>

                                <template #head()="data">
                                    <h6>{{ data.label.toUpperCase() }}</h6>
                                </template>
                            </b-table>

                        </b-form-row>
                        <b-row style="margin-top: 12px">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página
                                    {{ page }} de {{
                                        totalPage }} -
                                    {{ total }} registros</b-col>
                                <b-col cols="6"
                                    style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                    <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                        :options="perPageOptions">
                                    </b-form-select>
                                </b-col>
                            </b-col>
                            <b-col cols="6">
                                <div class="d-flex justify-content-end align-items-end">
                                    <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                        :per-page="perPage" :total-rows="total"></b-pagination>
                                </div>
                            </b-col>
                        </b-row>


                    </b-card>

                </b-form>
            </b-col>
        </b-row>
        <ModalModalFotoIBPAdicionar :idFoto="idFoto" :id="id" v-if="mostrarModal" @fecharModal="fecharModal"
            :edicao="edicao">
        </ModalModalFotoIBPAdicionar>
    </div>
</template>
<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalModalFotoIBPAdicionar from "@/core/components/Modals/ModalModalFotoIBPAdicionar.vue"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm";

import moment from "moment"

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        ModalModalFotoIBPAdicionar,
    },
    mixins: [FormResourceMixin, ListResourceMixin, ConfirmMixin],
    props: {
        id: Number,
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "",
        },


    },
    data() {
        return {
            mostrarModal: false,
            idFoto: null,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            edicao: false,
            form: {
                situacao: "1",
                nome: "",
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],
            },
            itensFields: [
                {
                    key: "dataCriacao",
                    label: "Data de Criação",
                    formatter: data => moment(String(data)).format("DD/MM/YYYY"),
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "nome",
                    label: "Nome",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "descricao",
                    label: "Descrição",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "principal",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },

                {
                    key: "edit",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "desativar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "remover",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
            ],
        }
    },
    watch: {
        page() {
            this.load()
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/foto-ibp`)
        this.form.id = this.id
        this.load()

    },

    methods: {
        showModal() {
            this.mostrarModal = true
        },
        fecharModal() {
            this.mostrarModal = false
            this.load()
        },
        cadastrar() {
            this.edicao = false
            this.showModal()
        },
        editar(item) {
            this.idFoto = item.cod
            this.edicao = true
            this.showModal()
        },
        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Foto do Item Bem Permanente?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },


        async deletar(cod) {

            this.busy = true;
            await this.$removeResource({id:cod})
            this.busy = false;  

        },
        atualizarPrincipal(id) {
            this.busy = true
            this.$service.put(`atualizarPrincipal/${id}/${this.id}`, {}).then(response => {
                this.busy = false
                this.load()
                this.$notify({
                    type: "success",
                    message: response.data,
                })
            })
        },
        async load() {
            this.params.nome = null
            this.params.situacao = null
            this.params.id = null

            if (this.form.id && this.form.id != "") {
                this.params.id = this.form.id
            }

            if (this.form.nome) {
                this.params.nome = this.form.nome
            }

            if (this.form.situacao) {
                this.params.situacao = this.form.situacao
            }

            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            })
        },
        clearForm() {
            this.form = {
                id: this.id,
                nome: "",
                situacao: "1",
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],
            }
        },
    },
}
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>
